import { render, staticRenderFns } from "./Formatted.vue?vue&type=template&id=7e1f3a08"
import script from "./Formatted.vue?vue&type=script&lang=js"
export * from "./Formatted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports